import { useMutation, useQueryClient } from '@tanstack/react-query';

import api from 'api/api';

interface UserAttributes {
  tour_completed?: boolean;
  questionnaire_completed?: boolean;
  first_session_completed?: boolean;
  use_cases?: string[];
  experience_level?: string;
  industry?: string;
}

const setUserAttributes = async (attributes: UserAttributes) => {
  const { data } = await api.post('/web/users/attributes', attributes);
  return data;
};

const useSetUserAttributes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: setUserAttributes,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['authProfile'] }, { cancelRefetch: false });
    },
  });
};

export default useSetUserAttributes;
